import { BASE_PATH } from "../../constants";
const CUSTOMER_CONSENT_ENDPOINT = `${BASE_PATH}customers/me/consent`;
const getCustomerConsentRequestUrl = ({ baseUrl, xSiteOrigin, }) => {
    const url = new URL(CUSTOMER_CONSENT_ENDPOINT, baseUrl);
    url.search = new URLSearchParams({
        ...(xSiteOrigin ? { "x-site-origin": xSiteOrigin } : {}),
    }).toString();
    return url.toString();
};
export default getCustomerConsentRequestUrl;
